import React from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";

import { Link } from "react-router-dom";

const DataTable = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },

    {
      path: "class_desc",
      label: "اسم",
      content: (e) => (
        <Link to={`/mis/classes/${e.class_id}/students`}>{e.class_desc}</Link>
      ),
    },
    { path: "time", label: "نوبت" },
    { path: "total_count", label: "تعداد محصل" },
    { path: "department", label: "دیپارتمنت" },
    { path: "faculty", label: "پوهنحی" },
    {
      path: "option",
      content: (e) => <Option Edit={{ form: "class-form", edit: e }} />,
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default DataTable;
